import React from "react";
import PropTypes from "prop-types";
import Constants from "rtr-constants";
import FilterInputPairs from "components/source/new_taxonomy/filter-input-pairs";
import Details from "components/source/new_taxonomy/details";

class MyRTRFilterFieldset extends React.Component {
  static propTypes = {
    fieldsetHeader: PropTypes.string,
    filters: PropTypes.object,
    idSuffix: PropTypes.string,
    keyName: PropTypes.string,
    maxCollapsedFilters: PropTypes.number,
    onChange: PropTypes.func,
    onDeselectProductCollectionFilter: PropTypes.func,
    shortlists: PropTypes.array,
    submitFilters: PropTypes.func,
  };

  static defaultProps = {
    shortlists: [],
  };

  state = {
    isOpen: true,
  };

  onMyRTRFilterChange = filter => {
    if (filter.filterGroupKey === "productCollections" && !filter.selected) {
      this.props.onDeselectProductCollectionFilter(filter.name);
    } else {
      this.props.onChange(filter);
      this.props.submitFilters();
    }
  };

  renderHeartsFilter = () => {
    const allHeartsFilterValue = {
      displayName: "All Hearts",
      id: "true",
      filterKey: "hearts",
    };

    return (
      <FilterInputPairs
        key={allHeartsFilterValue.filterKey}
        displayName={allHeartsFilterValue.displayName}
        filters={this.props.filters?.[allHeartsFilterValue.filterKey] ?? []}
        idSuffix={this.props.idSuffix}
        keyName={allHeartsFilterValue.filterKey}
        onChange={this.onMyRTRFilterChange}
        values={[allHeartsFilterValue]}
        showInformedFilters={false}
      />
    );
  };

  renderShortlistsFilter() {
    const { shortlists } = this.props;

    if (!shortlists || shortlists.length < 1) {
      return null;
    }

    const shortlistsFilterValues = shortlists
      // NW [EXPLANATION] 8/20/19: exclude the All Hearts filter from Shortlist filters - it behaves differently than a shortlist
      .filter(shortlist => shortlist.id !== Constants.ALL_HEARTS_SHORTLIST_ID)
      .map(shortlist => {
        return {
          id: shortlist.id,
          displayName: shortlist.name,
        };
      });
    const shortlistFilterKey = "productCollections";

    return (
      <FilterInputPairs
        key={shortlistFilterKey}
        displayName={"shortlists"}
        filters={this.props.filters?.[shortlistFilterKey] ?? []}
        idSuffix={this.props.idSuffix}
        keyName={shortlistFilterKey}
        maxCollapsedFilters={this.props.maxCollapsedFilters}
        onChange={this.onMyRTRFilterChange}
        values={shortlistsFilterValues}
        showInformedFilters={false}
      />
    );
  }

  renderPreviouslyRentedStyleFilter() {
    const previouslyRentedStyleFilterValue = {
      displayName: "Previously Rented",
      id: "true",
      filterKey: "previouslyRentedStyles",
    };

    return (
      <FilterInputPairs
        key={previouslyRentedStyleFilterValue.filterKey}
        displayName={previouslyRentedStyleFilterValue.displayName}
        filters={this.props.filters?.[previouslyRentedStyleFilterValue.filterKey] ?? []}
        idSuffix={this.props.idSuffix}
        keyName={previouslyRentedStyleFilterValue.filterKey}
        onChange={this.onMyRTRFilterChange}
        values={[previouslyRentedStyleFilterValue]}
        showInformedFilters={false}
      />
    );
  }

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  renderFilters = () => {
    const { isOpen } = this.state;

    if (!isOpen) {
      return null;
    }

    return (
      <>
        {this.renderHeartsFilter()}
        {this.renderShortlistsFilter()}
        {this.renderPreviouslyRentedStyleFilter()}
      </>
    );
  };

  render() {
    const { keyName, fieldsetHeader } = this.props;

    return (
      <Details
        key={keyName}
        className="filter-fieldset myrtr-filter-fieldset"
        isOpen={this.state.isOpen}
        onToggle={this.onToggle}
        title={fieldsetHeader || "My RTR"}>
        {this.renderFilters()}
      </Details>
    );
  }
}

export default MyRTRFilterFieldset;
